"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EVENTS_PROPERTIES_STRATEGY: function() {
        return _constants.EVENTS_PROPERTIES_STRATEGY;
    },
    TRACKING_EXTRA_ATTRIBUTES: function() {
        return _constants1.TRACKING_EXTRA_ATTRIBUTES;
    },
    TrackingJT: function() {
        return _rudderstack.Rudderstack;
    },
    TrackingV3: function() {
        return TrackingV3;
    }
});
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var _rudderstack = require("./providers/rudderstack");
var _constants = require("./providers/rudderstack/constants");
var _uri = require("./helpers/uri");
var _cookie = require("./helpers/cookie");
var _logger = require("./helpers/logger");
var _checkConfig = require("./helpers/checkConfig");
var _constants1 = require("./constants");
/**
 * Build the final JSON payload that will be sent. This function auto-generate
 * some properties of the payload when possible but all of them can be
 * overriden if needed (except for `idempotency_key` and `emit_time`).
 *
 * See https://github.com/jobteaser/data-tracking-plan/ for allowed properties for an event
 *
 * @param props - the specific data for this event (header data in `metadata`, version of
 * this event in `event` and event properties in `data` as defined in data-tracking-plan repo)
 * Return the JSON payload that will be sent
 */ var buildEventPayload = function(props) {
    var _props_headerData = props.headerData, headerData = _props_headerData === void 0 ? {} : _props_headerData, _props_data = props.data, data = _props_data === void 0 ? {} : _props_data, serviceOverride = props.serviceOverride, headerAttributesIdsToAdd = props.include;
    var session_impersonator_id = headerData // eslint-disable-line camelcase
    .session_impersonator_id, service = headerData.service, trackee_school_id = headerData.trackee_school_id, course_ids = headerData.course_ids;
    var subdomainMatch = window.location.hostname.match(_constants1.SUBDOMAIN_REGEXP);
    var localeMatch = window.location.pathname.match(_constants1.LOCALE_REGEXP);
    var defaultData = _object_spread_props._(_object_spread._({
        // AUTO-GENERATED "DATA" PROPS
        // The referrer of the current page
        referrer: document.referrer || "",
        // The URI of the current page
        uri: window.location.href,
        // The client application userAgent
        user_agent: navigator.userAgent,
        // All the query parameters as a string
        query_parameters: window.location.search,
        // Subdomain (e.g. www, preprod, edhec...)
        session_subdomain: subdomainMatch ? subdomainMatch[1] || "" : "",
        // ISO code of the website (fr, en...)
        trackee_locale: localeMatch ? localeMatch[1] || "" : ""
    }, (0, _uri.getUTMParameters)(window.location.search)), {
        // AUTO-INJECTED "DATA" PROPS (IF PRESENT IN HEADERDATA)
        session_impersonator_id: session_impersonator_id || _constants1.ZERO_UUID,
        trackee_school_id: trackee_school_id || _constants1.ZERO_UUID
    });
    if (Array.isArray(headerAttributesIdsToAdd) && headerAttributesIdsToAdd.includes(_constants1.TRACKING_EXTRA_ATTRIBUTES.COURSE_IDS)) {
        defaultData.course_ids = course_ids || [] // eslint-disable-line camelcase
        ;
    }
    return {
        visitor_id: (0, _cookie.getCookie)("visitor_id"),
        service: serviceOverride || service || _constants1.TRACKING_DEFAULT_SERVICE,
        data: JSON.stringify(_object_spread._({}, defaultData, data), /* Replacer function that converts undefined values in null ones, in order to be able to serialize them after. */ function(_, value) {
            return value === undefined ? null : value;
        })
    };
};
/**
 * Wrapper to build an "instance" of 2019-2020 tracker for new tracking stack - for Data purpose (!= Marketing purpose)
 */ var TrackingV3 = function TrackingV3() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, withRudderstackOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    // Init Rudderstack
    var rudderstack = (0, _rudderstack.Rudderstack)(config);
    if (!(0, _checkConfig.checkConfig)(config)) {
        return withRudderstackOnly ? _object_spread._({}, rudderstack) : null;
    }
    var headerDataProvider = config.headerDataProvider, debug = config.debug;
    var logger = (0, _logger.getLogger)(debug);
    var eventQueue = [];
    /**
   * Iterate on eventQueue and send all queued events. Clear the eventQueue when done.
   *
   * @param {Object} headerData - The tracker headerData that is used for all event emission
   */ var flushEventQueue = function(headerData) {
        eventQueue.forEach(function(param) {
            var _param = _sliced_to_array._(param, 3), eventName = _param[0], data = _param[1], options = _param[2];
            if (!options) {
                if (typeof options !== "undefined") {
                    logger.error('Invalid "options" passed to event "'.concat(eventName, '": ').concat(options, '. Expected "{ serviceOverride, include }" or "undefined".'));
                }
                // eslint-disable-next-line no-param-reassign
                options = {};
            }
            var serviceOverride = options.serviceOverride, include = options.include;
            var payload = buildEventPayload({
                headerData: headerData,
                data: data,
                serviceOverride: serviceOverride,
                include: include
            });
            var parsedPayloadData = JSON.parse(payload.data);
            // Do not send event if visitor_id is missing
            if (!payload.visitor_id) {
                logger.debug("Prevent event emission due to missing visitor_id");
                return;
            }
            rudderstack.send(eventName, parsedPayloadData, _object_spread_props._(_object_spread._({}, options), {
                service: payload.service,
                trackeeLocale: headerData.trackeeLocale
            }));
        });
        eventQueue = [];
    };
    /**
   * Add an event to the eventQueue and call headerDataProvider
   *
   * @param args - args are expected to be [eventName, eventProps, {serviceOverride, include}]
   */ var sendEvent = function(eventName, eventProps, options) {
        eventQueue.push([
            eventName,
            eventProps,
            options
        ]);
        if (typeof headerDataProvider === "function") {
            headerDataProvider(flushEventQueue);
        }
    };
    return _object_spread._({
        /**
     * Send page_view event for non-SPA pages
     *
     * @param version (_) - DEPRECATED - The JSON schema version this event conforms to
     * @param data - The data as detailled in JSON schema "properties"
     * @param [options] - see Options def.
     */ trackLegacyPageView: function(_, data, options) {
            sendEvent("page_view", data, options);
        },
        /**
     * Send page_view event for SPA pages
     *
     * @param version (_) - DEPRECATED - The JSON schema version this event conforms to
     * @param data - The data as detailled in JSON schema "properties"
     * @param [options] - see Options def.
     */ trackPageView: function(_, data, options) {
            sendEvent("page_view_spa", data, options);
        },
        /**
     * Send generic event for SPA & Legacy
     *
     * @param eventName - The event name as defined in the JSON schema
     * @param version (_) - DEPRECATED - The JSON schema version this event conforms to
     * @param data - The data as detailled in JSON schema "properties"
     * @param [options] - see Options def.
     */ /* eslint-disable-next-line max-params */ trackEvent: function(eventName, _, data, options) {
            sendEvent(eventName, data, options);
        }
    }, rudderstack);
};
if (typeof window !== "undefined") {
    window.TrackingJT = TrackingV3;
}

//# sourceMappingURL=index.js.map